import React, { Component } from "react";
import {getCurrentUser} from "../../services/authService";
import Button from "react-bootstrap/Button";
import Table from "../common/table";

class ManufacturersTable extends Component {
  columns = [
    {
      path: "manufacture_fullname",
      label: "Brand",
      icon: "tools",
      content: manufacturer => <Button variant="link" onClick={() => this.props.onEdit(manufacturer)}>{manufacturer.manufacturer_fullname}</Button>
    },
    { path: "country_of_origin", label: "Country of Origin", icon: "flag-usa" },
    { path: "years_active", label: "Years Active", icon: "calendar-alt" }
  ];

  editColumn = {
    key: "edit",
    icon: "edit",
    content: manufacturer => (
      <button
        onClick={() => { if (window.confirm('Are you sure you wish to edit this brand?')) this.props.onEdit(manufacturer) } }
        className="btn btn-info btn-sm"
      >
        Edit
      </button>
    )
  };
  deleteColumn = {
    key: "delete",
    icon: "trash-alt",
    content: manufacturer => (
      <button
        onClick={() => { if (window.confirm('Are you sure you wish to delete this brand and all models attached to it?')) this.props.onDelete(manufacturer) } }
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    )
  };

  constructor() {
    super();
    const user = getCurrentUser();
    if (user && user.role === "admin") this.columns.push(this.editColumn);
    if (user && user.role === "admin") this.columns.push(this.deleteColumn);
  }

  render() {
    const { data } = this.props;

    return (
      <Table
        columns={this.columns}
        data={data}
        keyColumn='manufacturer_id'
      />
    );
  }
}

export default ManufacturersTable;
